/** The id the `Osano` component gives its `<script>` tag. */
export const OSANO_SCRIPT_ID = "osano-script";

/**
 * Whether the page carries the Osano consent manager. The `Osano` component
 * renders its script tag only where `NEXT_PUBLIC_OSANO_URL` is set, so the
 * tag, not the env var, is what consent-gated tools check: it is what the
 * server actually put on the page.
 *
 * Compliance classified Datadog RUM as Analytics in Osano: where the consent
 * manager is on the page (production) RUM waits for the visitor's answer.
 * Where it is not (qa, stg, local) there is nobody to ask and RUM reports
 * as before.
 */
export function isConsentManagerOnPage(): boolean {
  return document.getElementById(OSANO_SCRIPT_ID) !== null;
}
